module.exports = __webpack_public_path__ + "static/media/multiomics.704fc8c6.png";